import { useState } from "react";
import { Handle, Position } from "reactflow";
import { MdCallMerge } from "react-icons/md";
import { AiOutlinePlus } from "react-icons/ai";

const ParallelFinishNode = ({
  id,
  onClick,
  onSerialAddClick,
  onFinishClick,
  isEditing,
  isEndNode,
  translate,
}) => {
  const [showAddOptions, setShowAddOptions] = useState(false);

  return (
    <div>
      <Handle type="target" position={Position.Top} id={`TargetTop${id}`} />
      <Handle type="target" position={Position.Right} id={`TargetRight${id}`} />
      <MdCallMerge
        className="fs-2 text-white bg-orange rounded-circle"
        onClick={onClick}
      />
      <p className="parallel-name ms-2 fs-5">{id}</p>
      <Handle
        type="source"
        position={Position.Bottom}
        id={`SourceBottom${id}`}
      />
      <Handle type="target" position={Position.Left} id={`TargetLeft${id}`} />
      {isEditing && (
        <span className="serial-add-node d-flex flex-row align-items-start justify-content-center">
          <span
            className="icon rounded-circle p-2 mt-1"
            onClick={() => setShowAddOptions(!showAddOptions)}
          >
            <AiOutlinePlus className="fs-5 text-white" />
          </span>
          {showAddOptions && (
            <div className="addOptions d-flex flex-column">
              <span
                className="addSerialOption fs-4 fw-semibold text-orange mt-1"
                onClick={() => {
                  setShowAddOptions(false);
                  onSerialAddClick();
                }}
              >
                {translate("design_approval_process.nodes.manual")}
              </span>
              {isEndNode && (
                <span
                  className="addFinishOption fs-4 fw-semibold text-orange"
                  onClick={() => {
                    setShowAddOptions(false);
                    onFinishClick();
                  }}
                >
                  {translate("design_approval_process.nodes.ending")}
                </span>
              )}
            </div>
          )}
        </span>
      )}
    </div>
  );
};

export default ParallelFinishNode;
